import { InGameCurrency, Rarity } from '#src/__generated__/globalTypes.ts';

export const WHEEL_TICKET_BY_RARITY: Record<Rarity, InGameCurrency> = {
  [Rarity.common]: InGameCurrency.COMMON_WHEEL_TICKET,
  [Rarity.limited]: InGameCurrency.WHEEL_TICKET,
  [Rarity.rare]: InGameCurrency.RARE_WHEEL_TICKET,
  [Rarity.super_rare]: InGameCurrency.SUPER_RARE_WHEEL_TICKET,
  [Rarity.unique]: InGameCurrency.UNIQUE_WHEEL_TICKET,
  [Rarity.custom_series]: InGameCurrency.COMMON_WHEEL_TICKET,
};

export const GOLDEN_WHEEL_TICKET_BY_RARITY: Record<Rarity, InGameCurrency> = {
  [Rarity.common]: InGameCurrency.COMMON_GOLDEN_WHEEL_TICKET,
  [Rarity.limited]: InGameCurrency.GOLDEN_WHEEL_TICKET,
  [Rarity.rare]: InGameCurrency.RARE_GOLDEN_WHEEL_TICKET,
  [Rarity.super_rare]: InGameCurrency.SUPER_RARE_GOLDEN_WHEEL_TICKET,
  [Rarity.unique]: InGameCurrency.UNIQUE_GOLDEN_WHEEL_TICKET,
  [Rarity.custom_series]: InGameCurrency.COMMON_GOLDEN_WHEEL_TICKET,
};

export const ALL_WHEEL_TICKETS = Object.values(WHEEL_TICKET_BY_RARITY);

const ALL_GOLDEN_WHEEL_TICKETS = Object.values(GOLDEN_WHEEL_TICKET_BY_RARITY);

export const ALL_WHEEL_CURRENCIES = [
  ...ALL_WHEEL_TICKETS,
  ...ALL_GOLDEN_WHEEL_TICKETS,
];

export const isWheelTicketCurrency = (
  currency: InGameCurrency
): currency is
  | typeof InGameCurrency.COMMON_WHEEL_TICKET
  | typeof InGameCurrency.WHEEL_TICKET
  | typeof InGameCurrency.RARE_WHEEL_TICKET
  | typeof InGameCurrency.SUPER_RARE_WHEEL_TICKET
  | typeof InGameCurrency.UNIQUE_WHEEL_TICKET =>
  ALL_WHEEL_TICKETS.includesValue(currency);

export const isGoldenWheelTicketCurrency = (
  currency: InGameCurrency
): currency is
  | typeof InGameCurrency.COMMON_GOLDEN_WHEEL_TICKET
  | typeof InGameCurrency.GOLDEN_WHEEL_TICKET
  | typeof InGameCurrency.RARE_GOLDEN_WHEEL_TICKET
  | typeof InGameCurrency.SUPER_RARE_GOLDEN_WHEEL_TICKET
  | typeof InGameCurrency.UNIQUE_GOLDEN_WHEEL_TICKET =>
  ALL_GOLDEN_WHEEL_TICKETS.includesValue(currency);
